export default __webpack_public_path__ + "static/media/logo-AT-desktop.82181f05.svg";